export const ATTACHMENT_BATCH_RECORD_LIMITS = [1, 10, 100, 1000, 2000, 3000, 5000] as const;

export type AttachmentBatchRecordLimit = typeof ATTACHMENT_BATCH_RECORD_LIMITS[number];

export function estimateAttachmentBatchApiCalls(input: {
  scanRecordCount: number;
  updateRecordCount: number;
  fixedCheckCalls?: number;
}) {
  const scanCalls = Math.ceil(input.scanRecordCount / 500);
  const updateCalls = Math.ceil(input.updateRecordCount / 100);
  const checkCalls = input.fixedCheckCalls ?? 0;
  return { total: scanCalls + updateCalls + checkCalls, scanCalls, updateCalls, checkCalls };
}

export function AttachmentBatchScopeControls({ maxRecordCount, onChange, continuationId, onContinuationChange,
  previousExecutionId, estimate, collapsible = false }: {
  maxRecordCount: AttachmentBatchRecordLimit; onChange(value: AttachmentBatchRecordLimit): void;
  continuationId: string; onContinuationChange(value: string): void;
  previousExecutionId?: string;
  collapsible?: boolean;
  estimate: ReturnType<typeof estimateAttachmentBatchApiCalls>;
}) {
  const controls = <fieldset className="space-y-2 rounded-md border border-border p-3 text-sm">
    <legend className="px-1 font-medium">今回の処理範囲</legend>
    <label className="flex items-center gap-2">最大レコード数
      <select value={maxRecordCount} onChange={event => onChange(Number(event.target.value) as AttachmentBatchRecordLimit)}>
        {ATTACHMENT_BATCH_RECORD_LIMITS.map(limit => <option key={limit} value={limit}>{limit}件</option>)}
      </select>
    </label>
    <label className="block">開始位置
      <select className="ml-2" value={continuationId} onChange={event => onContinuationChange(event.target.value)}>
        <option value="">先頭から試行</option>
        {previousExecutionId ? <option value={previousExecutionId}>前回の選択範囲の続き</option> : null}
      </select>
    </label>
    <p>推定API実行回数（日次制限の対象）：約{estimate.total}回</p>
  </fieldset>;
  return collapsible ? <div className="space-y-1 text-sm">
    <p>今回の処理範囲：最大{maxRecordCount}件・{continuationId ? "前回の選択範囲の続き" : "先頭から試行"}</p>
    <details data-maintenance-options>
      <summary className="cursor-pointer py-2">処理範囲のオプション{maxRecordCount !== 1000 || continuationId ? "（変更あり）" : ""}</summary>
      {controls}
    </details>
  </div> : controls;
}
